// extracted by mini-css-extract-plugin
export var container = "_re-0";
export var dotAnimation = "_re-2";
export var dotsLoading = "_re-1";